module.exports = __webpack_public_path__ + "static/media/blue sphere horizon.26358022.png";